<template>
  <v-card v-if="network">
    <v-toolbar>
      <v-icon>computer</v-icon>
      <v-toolbar-title>{{$t('menu.cabled')}}</v-toolbar-title>
    </v-toolbar>
    <network-setting-status prefix="eth0"></network-setting-status>
    <v-toolbar>
      <v-icon>wifi</v-icon>
      <v-toolbar-title>{{$t('menu.wireless')}}</v-toolbar-title>
    </v-toolbar>

    <network-setting-status prefix="wlan0"></network-setting-status>
    <network-wifi-list v-if="network.wlan0_power == 'on' && !loading"></network-wifi-list>
  </v-card>
  <v-layout align-center justify-center fill-height v-else>
    <v-progress-circular indeterminate></v-progress-circular>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import NetworkSettingStatus from "./NetworkSettingStatus";
import NetworkWifiList from "./NetworkWifiList";
export default {
  name: "NetworkSettings",
  components: {
    NetworkSettingStatus,
    NetworkWifiList
  },
  created() {
    this.$store.dispatch("fetchNetwork");
  },
  computed: {
    ...mapGetters(["network", "loading"])
  },
  methods: {}
};
</script>
